import {
  CLEAR_USERS,
  SET_USERS,
  SET_ROLES,
  SET_ROLE_TYPES,
  SET_ORGS,
  SET_EDIT,
  RESET_EDIT,
  SET_EDITOR_ERROR,
  SET_EDITOR_SUCCESS,
} from '../actions/actiontypes';
import { groupByProperty } from '../../utils/collections';
import { stableSort, compareByNumericProp } from '../../utils/comparators';

const EMPTY_EDIT = {
  editType: 'NONE',
  data: {},
  id: null,
  error: '',
  saved: false,
};

const DEFAULT_STATE = {
  users: [],
  byId: {},
  roles: [],
  roleTypes: [],
  organizations: [],
  orgsById: {},
  editing: EMPTY_EDIT,
};

export default function users(
  state = {
    users: [],
    byId: {},
    roles: [],
    roleTypes: [],
    organizations: [],
    orgsById: {},
    editing: EMPTY_EDIT,
  },
  action
) {
  switch (action.type) {
    case CLEAR_USERS:
      return DEFAULT_STATE;
    case SET_USERS:
      return {
        ...state,
        byId: groupByProperty('id', action.data),
        users: action.data,
      };
    case SET_ROLES:
      return {
        ...state,
        roles: action.data,
      };
    case SET_ROLE_TYPES:
      return {
        ...state,
        roleTypes: action.data,
      };
    case SET_ORGS:
      return {
        ...state,
        organizations: stableSort(action.data, compareByNumericProp('name')),
        orgsById: groupByProperty('id', action.data),
      };
    case RESET_EDIT:
      return {
        ...state,
        editing: EMPTY_EDIT,
      };
    case SET_EDIT:
      return {
        ...state,
        editing: {
          ...action.edit,
          error: state.editing.error,
        },
      };
    case SET_EDITOR_ERROR:
      return {
        ...state,
        editing: {
          ...state.editing,
          error: action.message,
        },
      };
    case SET_EDITOR_SUCCESS:
      return {
        ...state,
        editing: {
          ...state.editing,
          success: 'Saved',
        },
      };
    default:
      return state;
  }
}
